import * as React from 'react';
import { Page } from '~/components/technology-js-page/technology-js-page';

const TechnologyPage: React.FC = () => <Page />;

export default TechnologyPage;
